import { CaretDown, Files, Info, ShoppingCart, SignOut, User, UserSwitch, X } from 'phosphor-react'
import { Fragment, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { setBusqueda } from '../../actions/articulos'
import { getMenuFamilias, setFamiliaSeleccionada } from '../../actions/familias'
import { anadirFiltro, limpiarFiltros, limpiarFiltrosTexto } from '../../actions/filtros'
import { changeLanguage, getLanguages } from '../../actions/languageSelector'
import { getListasCompra } from '../../actions/listasCompra'
import { getNovedades } from '../../actions/novedades'
import { getOfertas } from '../../actions/ofertas'
import { getPedidoActivo } from '../../actions/pedidos'
import { getMenus } from '../../actions/portal'
import { getTiras } from '../../actions/tiras'
import config from '../../config'
import { ordenarMenu, programaActivo } from '../../helpers/funciones'
import i18n from '../../lang/idiomas'
import Buscador from '../ecommerce/Buscador'
import Carrito from '../ecommerce/Carrito'
import SelectorClienteBuscador from '../usuarios/SelectorClienteBuscador'

import '../../css/header.css'
import { propsNuevaPestana } from '../../helpers/urls/menu'
let menusMostrar = []

const Header = props => {
  const dispatch = useDispatch()

  const auth = useSelector(state => state.auth)
  const pedido = useSelector(state => state.pedidos.pedido)
  const portal = useSelector(state => state.portal.portal)
  const menus = useSelector(state => state.portal.menus)
  const cookies = useSelector(state => state.portal.cookies)
  const id_pedido_seleccionado = useSelector(state => state.pedidos.id_pedido_seleccionado)
  const ofertas = useSelector(state => state.listadoArticulos.ofertas)
  const novedades = useSelector(state => state.listadoArticulos.novedades)
  const language = useSelector(state => state.languageSelector.language)
  const clientesPermitidos = useSelector(state => state.auth.user.clientes_permitidos)
  const clienteSeleccionado = useSelector(state => state.selectorCliente.cliente_seleccionado)
  const familias = useSelector(state => state.familias.familias)
  const languages = useSelector(state => state.languageSelector.languages)
  const [familiaDropdownOpen, setFamiliaDropdownOpen] = useState(false)
  const [familiasMobileOpen, setFamiliasMobileOpen] = useState(false)
  const familiaDropdownRef = useRef(null)
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false)
  const [idiomasMobileOpen, setIdiomasMobileOpen] = useState(false)
  const languageDropdownRef = useRef(null)
  const navigate = useNavigate()
  const prevProps = useRef()
  const mobileMenuRef = useRef(null)
  const wookieCalled = useRef(false)

  useEffect(() => {
    dispatch(getMenus())
    if (typeof window.wookie !== undefined) {
      window.wookie()
    } else {
      console.log('No se encuentra librería wookie')
    }
    if (!familias || familias.length === 0) {
      dispatch(getMenuFamilias())
    }
    dispatch(getLanguages())

    const header = document.getElementById('cabecera-principal')
    const cerrarDropdownActivo = e => {
      const toggle = e.target.closest('.tt-dropdown-toggle')
      if (toggle) {
        const dropdownObj = toggle.closest('.tt-dropdown-obj')
        if (
          dropdownObj &&
          dropdownObj.classList.contains('active') &&
          !dropdownObj.classList.contains('tt-search')
        ) {
          e.stopPropagation()
          dropdownObj.classList.remove('active')
          document.body.classList.remove('tt-popup-dropdown')
        }
      }
    }
    if (header) header.addEventListener('click', cerrarDropdownActivo, true)
    return () => {
      if (header) header.removeEventListener('click', cerrarDropdownActivo, true)
    }
  }, [auth.isAuthenticated, language])

  useEffect(() => {
    if (menus?.length > 0 && portal.descripcion) {
      // Si existe el menu novedadesOfertas
      if (programaActivo(menus, 'novedadesOfertas')) {
        if (ofertas.articulos === undefined) {
          dispatch(getOfertas())
        }

        if (novedades.articulos === undefined) {
          dispatch(getNovedades())
        }
      }
      // Si existen articulos recuperamos pedido y tiras
      if (!auth.invitado && programaActivo(menus, 'articulos')) {
        dispatch(
          getPedidoActivo(
            auth.hash != null ? auth.hash : '',
            'N',
            id_pedido_seleccionado || pedido?.id_pedido,
          ),
        )
        dispatch(getTiras())
      }

      // Si existen listasCompra las solicitamos
      if (programaActivo(menus, 'listasCompra')) {
        dispatch(getListasCompra())
      }
    }
  }, [portal, menus])

  useEffect(() => {
    if (
      familias &&
      familias.length > 0 &&
      typeof window.wookie === 'function' &&
      !wookieCalled.current
    ) {
      window.wookie()
      wookieCalled.current = true
    }
  }, [familias])

  useEffect(() => {
    const handleClickOutside = e => {
      if (familiaDropdownRef.current && !familiaDropdownRef.current.contains(e.target)) {
        setFamiliaDropdownOpen(false)
      }
      if (languageDropdownRef.current && !languageDropdownRef.current.contains(e.target)) {
        setLanguageDropdownOpen(false)
      }
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(e.target) &&
        !e.target.closest('[data-panel], .tt-menu-toggle, .mm-toggle-btn') &&
        mobileMenuRef.current.classList.contains('mmitemopen')
      ) {
        ocultarMenu()
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [])

  const ocultarMenu = e => {
    const menu = document.getElementsByClassName('mobile-main-menu')[0]
    menu.classList.remove('mmitemopen')
    menu.querySelectorAll('li.mm-opened').forEach(li => li.classList.remove('mm-opened'))
    setFamiliasMobileOpen(false)
    setIdiomasMobileOpen(false)
  }

  const cargarIcono = menu => {
    if (menu.programa) {
      switch (menu.programa) {
        case 'login':
          return (
            <User
              size={22}
              weight='regular'
            />
          )
        case 'informes':
          return (
            <Files
              size={22}
              weight='regular'
            />
          )
        case 'contacto':
          return (
            <Info
              size={22}
              weight='regular'
            />
          )
        case 'cuenta':
          return (
            <User
              size={20}
              weight='fill'
            />
          )
        case 'logout':
          return (
            <SignOut
              size={20}
              weight='fill'
            />
          )
        case 'selectorCliente':
          return (
            <UserSwitch
              size={22}
              weight='fill'
            />
          )
        default:
          return ''
      }
    } else if (menu.nombre && (menu.nombre === 'USUARIO' || menu.nombre === 'CARRITO')) {
      if (menu.nombre === 'USUARIO') {
        return (
          <User
            size={22}
            weight='regular'
          />
        )
      } else {
        return (
          <ShoppingCart
            size={22}
            weight='regular'
          />
        )
      }
    }
  }

  const { isAuthenticated, user } = auth
  const { lineas } = pedido
  let ofertaAT = ofertas.articulos_total
  let novedadAT = novedades.articulos_total
  const invitado = auth.invitado

  menusMostrar = menus
  if (menusMostrar && menusMostrar.length > 0) {
    menusMostrar = menusMostrar.sort(ordenarMenu)
    if (auth.isAuthenticated && !invitado) {
      menusMostrar = menusMostrar.filter(menu => {
        return menu.programa !== 'login' && menu.programa !== 'registro'
      })
    }
    if (auth.user && auth.user.puede_crear_usuarios !== 'S') {
      menusMostrar = menusMostrar.filter(menu => {
        return menu.programa !== 'registroHijos'
      })
    }
  }
  const retornarMenu = (menu, origen) => {
    if (menu?.programa?.substring(0, 4) === 'http') {
      return (
        <a
          href={menu.programa}
          onClick={origen === 'mobile' ? ocultarMenu : null}
          {...propsNuevaPestana(menu.programa)}>
          {menu.icono ? cargarIcono(menu) : ''}
          {menu.nombre.charAt(0).toUpperCase() + menu.nombre.slice(1).toLowerCase()}
        </a>
      )
    } else if (menu.programa === null && menu?.hijos?.length > 0) {
      return (
        <Link
          onClick={origen === 'mobile' ? ocultarMenu : null}
          to={
            '/' + menu.hijos[0].programa + (menu.hijos[0].camino ? '/' + menu.hijos[0].camino : '')
          }>
          {menu.nombre.charAt(0).toUpperCase() + menu.nombre.slice(1).toLowerCase()}
        </Link>
      )
    } else {
      return (
        <Link
          onClick={origen === 'mobile' ? ocultarMenu : null}
          to={'/' + menu.programa + (menu.camino ? '/' + menu.camino : '')}>
          {menu.icono ? cargarIcono(menu) : ''}
          {menu.nombre.charAt(0).toUpperCase() + menu.nombre.slice(1).toLowerCase()}
        </Link>
      )
    }
  }

  const retornarHijos = (menu, origen) => {
    return menu.hijos.map(hijo => {
      return hijo.visible === 'S' ? (
        <li key={hijo.id}>
          <Link
            onClick={origen === 'mobile' ? ocultarMenu : null}
            to={'/' + hijo.programa + (hijo.camino ? '/' + hijo.camino : '')}>
            {hijo.nombre}
          </Link>
        </li>
      ) : (
        ''
      )
    })
  }

  const seleccionarFamilia = familia => {
    dispatch(limpiarFiltros())
    dispatch(limpiarFiltrosTexto())
    dispatch(setBusqueda(''))
    dispatch(
      setFamiliaSeleccionada(familia.numero_tabla, familia.codigo_familia, familia.descripcion),
    )
    dispatch(
      anadirFiltro({
        estadistico: familia.numero_tabla,
        familia: familia.codigo_familia,
        nombre: familia.descripcion,
        tipo: 'estad',
      }),
    )
    navigate('/articulos')
  }

  const flagMap = { PT: 'pt-pt' }
  const getFlagUrl = code => {
    const key = code?.toUpperCase()
    const filename = flagMap[key] || code?.toLowerCase()
    return `https://casalsmd.com/wp-content/plugins/sitepress-multilingual-cms/res/flags/${filename}.png`
  }

  const seleccionarIdioma = code => {
    dispatch(changeLanguage(code))
    i18n.changeLanguage(code.toLowerCase())
    setLanguageDropdownOpen(false)
  }

  const desktoLinks = (
    <div className='tt-obj-menu'>
      <div className='container'>
        <div className='row justify-content-md-start no-gutters'>
          <div className='tt-desctop-parent-menu tt-parent-box'>
            <div className='menu'>
              <nav>
                <ul>
                  {menusMostrar && menusMostrar.length > 0 ? (
                    <>
                      {menusMostrar.map(menu => {
                        menu.hijos.sort(ordenarMenu)
                        return menu.visible === 'S' &&
                          menu.objeto_programa !== 'CARRITO' &&
                          menu.objeto_programa !== 'USUARIO' &&
                          menu.objeto_programa !== 'SELECTOR_CLIENTE' ? (
                          <Fragment key={menu.id}>
                            <li className='dropdown  tt-megamenu-col-01'>
                              {retornarMenu(menu, 'desktop')}
                              {menu.programa === 'novedadesOfertas' &&
                              ofertaAT &&
                              novedadAT &&
                              (ofertaAT !== 0 || novedadAT !== 0) ? (
                                <span className='tt-badge-news'>
                                  {ofertaAT !== 0 || novedadAT !== 0 ? ofertaAT + novedadAT : ''}
                                </span>
                              ) : (
                                ''
                              )}
                              {menu.hijos.length > 0 ? (
                                <Fragment>
                                  <div className='dropdown-menu'>
                                    <div className='row tt-col-list'>
                                      <div className='col'>
                                        <ul className='tt-megamenu-submenu'>
                                          {retornarHijos(menu, 'desktop')}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </Fragment>
                              ) : (
                                ''
                              )}
                            </li>
                            {/* Familias movido a la fila 2 del header (categoriasDropdown) */}
                          </Fragment>
                        ) : (
                          ''
                        )
                      })}
                    </>
                  ) : (
                    ''
                  )}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  const mobileMenu = (
    <ul className='menu-mobile'>
      {menusMostrar && menusMostrar.length > 0 ? (
        <>
          {menusMostrar.map(menu => {
            menu.hijos.sort(ordenarMenu)
            return menu.visible === 'S' &&
              menu.objeto_programa !== 'CARRITO' &&
              menu.objeto_programa !== 'SELECTOR_CLIENTE' ? (
              <Fragment key={menu.id}>
                <li>
                  {retornarMenu(menu, 'mobile')}
                  {menu.hijos.length > 0 ? <ul>{retornarHijos(menu, 'mobile')}</ul> : ''}
                </li>
              </Fragment>
            ) : (
              ''
            )
          })}
          {!isAuthenticated ? (
            <li>
              <Link to='/altacliente'>ALTA CLIENTE</Link>
            </li>
          ) : null}
          {languages && languages.length > 1 && language ? (
            <li className='menu-idiomas'>
              <button
                type='button'
                className={'menu-idiomas-tit' + (idiomasMobileOpen ? ' abierto' : '')}
                onClick={() => setIdiomasMobileOpen(!idiomasMobileOpen)}>
                <span>{i18n.t('general.idioma', 'Idioma')}</span>
                <CaretDown
                  size={14}
                  weight='bold'
                />
              </button>
              {idiomasMobileOpen ? (
                <ul className='familias-mobile-list'>
                  {languages
                    .filter(l => l.codigo_idioma.toUpperCase() !== language?.toUpperCase())
                    .map(l => (
                      <li key={l.codigo_idioma}>
                        <a
                          href='#'
                          className={
                            l.codigo_idioma.toUpperCase() === language?.toUpperCase()
                              ? 'activo'
                              : ''
                          }
                          onClick={e => {
                            e.preventDefault()
                            seleccionarIdioma(l.codigo_idioma)
                            ocultarMenu()
                          }}>
                          <img
                            src={getFlagUrl(l.codigo_idioma)}
                            alt={l.codigo_idioma}
                            className='lang-flag'
                          />
                          {l.codigo_idioma.toUpperCase()}
                        </a>
                      </li>
                    ))}
                </ul>
              ) : (
                ''
              )}
            </li>
          ) : (
            ''
          )}
        </>
      ) : (
        ''
      )}
    </ul>
  )

  // ── Fila 1 (utility): selector cliente + contacto ──
  const desktopUtility = (
    <div className='header-utility'>
      {menusMostrar && menusMostrar.length > 0
        ? menusMostrar.map(menu => {
            return menu.visible === 'S' &&
              menu.objeto_programa === 'SELECTOR_CLIENTE' &&
              clientesPermitidos !== undefined &&
              clientesPermitidos.length > 1 ? (
              <div
                key='boton_selector_cliente'
                className='tt-desctop-parent-client-select tt-parent-box'>
                <div
                  className='tt-client-select tt-dropdown-obj'
                  data-tposition='bottom'>
                  <SelectorClienteBuscador />
                </div>
              </div>
            ) : (
              ''
            )
          })
        : ''}
      <div className='tt-parent-box tt-parent-contacto'>
        {config.contacto.telefono !== '' && (
          <a href={`tel:${config.contacto.telefono}`}>
            <i className='fas fa-phone' /> {config.contacto.telefono}
          </a>
        )}
      </div>
      <div className='tt-parent-box tt-parent-contacto'>
        {config.contacto.email !== '' && (
          <a href={`mailto:${i18n.t('layout.cas_emai')}`}>
            <i className='fas fa-envelope' /> {i18n.t('layout.cas_emai')}
          </a>
        )}
      </div>
      <div>
        {language && (
          <li
            ref={languageDropdownRef}
            className='dropdown tt-megamenu-col-01'
            style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
            <a
              href='#'
              onClick={e => {
                e.preventDefault()
                if (languages && languages.length > 1)
                  setLanguageDropdownOpen(!languageDropdownOpen)
              }}>
              <img
                src={getFlagUrl(language)}
                alt={language}
                className='lang-flag'
              />
              <span>{language?.toUpperCase()}</span>
            </a>
            {languageDropdownOpen && languages && (
              <ul
                className='familias-dropdown-menu'
                style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
                {languages
                  .filter(l => l.codigo_idioma.toUpperCase() !== language?.toUpperCase())
                  .map(l => (
                    <li key={l.codigo_idioma}>
                      <a
                        href='#'
                        onClick={e => {
                          e.preventDefault()
                          seleccionarIdioma(l.codigo_idioma)
                        }}>
                        <img
                          src={getFlagUrl(l.codigo_idioma)}
                          alt={l.codigo_idioma}
                          className='lang-flag'
                        />
                        {l.codigo_idioma.toUpperCase()}
                      </a>
                    </li>
                  ))}
              </ul>
            )}
          </li>
        )}
      </div>
    </div>
  )

  // ── Fila 2 (derecha) ──
  const desktopActions = (
    <>
      {menusMostrar && menusMostrar.length > 0
        ? menusMostrar.map(menu => {
            if (menu.visible === 'S' && menu.objeto_programa === 'USUARIO') {
              menu.hijos.sort(ordenarMenu)
            }
            return menu.visible === 'S' && menu.objeto_programa === 'USUARIO' && !invitado ? (
              <div
                key='boton_usuario'
                className='tt-desctop-parent-account tt-parent-box'>
                <div className='tt-account tt-dropdown-obj'>
                  <button
                    className='tt-dropdown-toggle mi-cuenta'
                    data-tposition='bottom'
                    title={isAuthenticated ? user.nombre : ''}>
                    {menu.icono ? cargarIcono(menu) : ''}{' '}
                    <small>{isAuthenticated ? user.nombre || user.usuario_web : ''}</small>
                  </button>
                  <div className='tt-dropdown-menu sub-mi-cuenta'>
                    <div className='tt-mobile-add'>
                      <button className='tt-close'>{i18n.t('general.cerrar')}</button>
                    </div>

                    <div className='cuenta-header'>
                      <div className='cuenta-avatar'>
                        <User
                          size={22}
                          weight='bold'
                        />
                      </div>
                      <div className='cuenta-id'>
                        <span className='cuenta-nombre'>{user.nombre || user.usuario_web}</span>
                        {user.nombre && user.usuario_web && user.nombre !== user.usuario_web ? (
                          <span className='cuenta-sub'>{user.usuario_web}</span>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                    <div className='tt-dropdown-inner'>
                      <ul>
                        {menu.hijos.map(hijo => {
                          return hijo.visible === 'S' ? (
                            <li key={hijo.id}>
                              <Link to={'/' + hijo.programa}>
                                {cargarIcono(hijo)}
                                {hijo.nombre}
                              </Link>
                            </li>
                          ) : (
                            ''
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )
          })
        : ''}
      {menusMostrar && menusMostrar.length > 0
        ? menusMostrar.map(menu => {
            return menu.visible === 'S' &&
              menu.objeto_programa === 'CARRITO' &&
              isAuthenticated &&
              !invitado ? (
              <div
                key='boton_carrito'
                className='tt-desctop-parent-cart tt-parent-box'>
                <div
                  className='tt-cart tt-dropdown-obj'
                  //data-tooltip="Carrito"
                  data-tposition='bottom'>
                  <button className='tt-dropdown-toggle'>
                    {menu.icono ? cargarIcono(menu) : ''}
                    <span className='tt-badge-cart'>{lineas ? lineas.length : '0'}</span>
                  </button>
                  <Carrito />
                </div>
              </div>
            ) : (
              ''
            )
          })
        : ''}
    </>
  )

  return (
    <header id='cabecera-principal'>
      <div className='header-envio-bar'>
        <i className='fas fa-truck' /> {i18n.t('layout.lenviodi')}
      </div>
      <nav
        ref={mobileMenuRef}
        className='panel-menu mobile-main-menu mm-right'>
        <div className='mm-navbtn-names'>
          <div
            className='mm-closebtn'
            style={{ marginTop: '15px', marginRight: '15px' }}>
            <X
              size={16}
              weight='bold'
            />
          </div>
        </div>
        {mobileMenu}
      </nav>
      <div className='tt-mobile-header'>
        <div className='container-fluid'>
          {/* Fila superior: hamburguesa + logo + carrito */}
          <div className='tt-header-row mobile-top-row'>
            <div className='mobile-parent-menu'>
              <div className='tt-menu-toggle'>
                <i className='icon-03'></i>
              </div>
            </div>
            <Link
              to={'/'}
              className='tt-logo tt-logo-alignment tt-mobile-logo'>
              <img
                src='/assets/img/casals_logo.png'
                alt=''
                className='loading'
                data-was-processed='true'
              />
            </Link>
            <div className='mobile-cart'>
              {menusMostrar && menusMostrar.length > 0
                ? menusMostrar.map(menu =>
                    menu.visible === 'S' &&
                    menu.objeto_programa === 'CARRITO' &&
                    isAuthenticated &&
                    !invitado ? (
                      <div
                        key='boton_carrito_movil'
                        className='tt-cart tt-dropdown-obj'
                        data-tposition='bottom'>
                        <button className='tt-dropdown-toggle'>
                          {menu.icono ? cargarIcono(menu) : ''}
                          <span className='tt-badge-cart'>{lineas ? lineas.length : '0'}</span>
                        </button>
                        <Carrito />
                      </div>
                    ) : (
                      ''
                    ),
                  )
                : ''}
            </div>
          </div>
          {/* Fila buscador a todo el ancho */}
          {isAuthenticated && !invitado && (
            <div className='mobile-search-bar'>
              <Buscador header={true} />
            </div>
          )}
        </div>
        <div className='tt-mobile-contact'>
          {config.contacto.telefono !== '' && (
            <a href={`tel:${config.contacto.telefono}`}>
              <i className='fas fa-phone' /> {config.contacto.telefono}
            </a>
          )}
          {config.contacto.email !== '' && (
            <a href={`mailto:${i18n.t('layout.cas_emai')}`}>
              <i className='fas fa-envelope' /> {i18n.t('layout.cas_emai')}
            </a>
          )}
        </div>
      </div>
      <div className='tt-desktop-header'>
        <div className='tt-color-scheme-01'>
          {/* ── Fila 1: utility ── */}
          <div className='header-row-1'>
            <div className='tt-obj-logo'>
              <Link
                to={'/'}
                className='tt-logo tt-logo-alignment'>
                <img
                  src='/assets/img/casals_logo.png'
                  alt=''
                  className='loading'
                  data-was-processed='true'
                />
              </Link>
            </div>
            {desktoLinks}
            {desktopUtility}
          </div>

          {/* ── Fila 2: categorías + buscador + acciones ── */}
          {isAuthenticated && !invitado && (
            <div className='header-row-2'>
              <div className='header-search'>
                <Buscador header={true} />
              </div>
              <div className='header-actions'>{desktopActions}</div>
            </div>
          )}
        </div>
      </div>
      <div className='tt-stuck-nav disabled'>
        <div className='container'>
          <div className='tt-header-row '>
            <div className='tt-stuck-parent-search tt-parent-box'></div>
            <div className='tt-stuck-parent-cart tt-parent-box'></div>
            <div className='tt-stuck-parent-account tt-parent-box'></div>
            <div className='tt-stuck-parent-multi tt-parent-box'></div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
